import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import URLs from "constants/urls";
import Cookie from "js-cookie";
import PropTypes from "prop-types";
import {
  Box,
  Table,
  TableBody,
  TextField,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  Dialog,
  DialogContentText,
  DialogContent,
  DialogActions,
  CircularProgress,
  Typography,
  Autocomplete,
} from "@mui/material";
import {
  StyledButton,
  StyledAlert,
  StyledSnackbar,
  CustomTableCell,
  inputStyle,
} from "components/StyledComponents/styledComponents.js";
import { monthEndStyles } from "components/Styles/monthEndStyles";
import { CustomPaper, autoSelectStyle, globalStyles } from "components/Styles/globalStyles";
import useBusinessMonthYear from "components/GlobalHooks/useMonthlyBusiness";
import { subDialogContentStyle, dialogContentTextStyle } from "components/Styles/approvalStyles";
import { useNavigate } from "react-router-dom";
import { useMaterialUIController } from "context";

export default function MonthlyOverView({ url, isItByDsa = false }) {
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [businessMonthID, setBusinessMonthID] = useState(0);
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  const MInput = inputStyle();
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const jwt_token = Cookie.get("jwt_token");
  //i want to add extraa fileds update cheesy Addithoonal Ga add chesaaa "connectorsCaseLessPayments,"connectorPayments" to the below row

  const [monthEndDetails, setMonthEndDetails] = useState({
    businessMonthId: 0,
    businessDate: "0",
    grossPayoutOnLoan: 0,
    grossPayoutPlusRecoveries: 0,
    additionalPayout: 0,
    recoveries: 0,
    grossPayoutOnInsurance: 0,
    grossPayoutOnMutualFund: 0,
    dsaPayoutAmountOnInsurance: 0,
    dsaPayoutAmountOnMutualFund: 0,
    dsaPayoutAmountOnLoan: 0,
    userName: "0",
    status: "0",
    tds: 0,
    netPayoutAfterTDS: 0,
    netRevenue: 0,
    salary: 0,
    netRevenueAfterSalary: 0,
    opex: 0,
    netRevenueAfterOPEX: 0,
    retentionPercent: 0,
    dmapayout: 0,
    connectorsCaseLessPayments: 0,
    connectorPayments: 0,
  });

  const handleCloseDailog = () => {
    setOpenDialog(false);
  };

  const { monthIdData, loadingBId, message, alertType, setAlert, open, handleClose, fetchData } =
    useBusinessMonthYear();
  const [totalGrossPayout, setTotalGrossPayout] = useState(0);
  const [totalDsaPayouts, setTotalDsaPayouts] = useState(0);
  const [netProfit, setNetProfit] = useState(0);

  // ─── helper: format INR ────────────────────────────────────────────────────
  const fmtINR = (val) =>
    `₹ ${Math.round(val || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const getMonthEndDetails = async () => {
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const finalUrl = isItByDsa
        ? `${url}/${businessMonthID}/${user.companyId}`
        : `${url}/${businessMonthID}`;
      const response = await fetch(finalUrl, options);
      if (response.ok) {
        const data = await response.json();
        setMonthEndDetails(data.data);
        setBusinessMonthID(data.data.businessMonthId || data.businessMonthId);
      } else {
        const errorData = await response.json();
        setAlert(errorData.message || "Failed to fetch data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    }
    setLoading(false);
  };

  const saveMonthEndDetails = async () => {
    const saveUrl = URLs.monthEndUrl;
    const monthEndPayload = {
      businessMonthId: monthEndDetails.businessMonthId,
      businessDate: monthEndDetails.businessDate,
      grossPayoutOnLoan: monthEndDetails.grossPayoutOnLoan,
      grossPayoutPlusRecoveries: monthEndDetails.grossPayoutPlusRecoveries,
      additionalPayout: monthEndDetails.additionalPayout,
      recoveries: monthEndDetails.recoveries,
      grossPayoutOnInsurance: monthEndDetails.grossPayoutOnInsurance,
      grossPayoutOnMutualFund: monthEndDetails.grossPayoutOnMutualFund,
      dsaPayoutAmountOnInsurance: monthEndDetails.dsaPayoutAmountOnInsurance,
      dsaPayoutAmountOnMutualFund: monthEndDetails.dsaPayoutAmountOnMutualFund,
      dsaPayoutAmountOnLoan: monthEndDetails.dsaPayoutAmountOnLoan,
      userName: user.employeeId,
      status: monthEndDetails.status,
      tds: monthEndDetails.tds,
      netPayoutAfterTDS: monthEndDetails.netPayoutAfterTDS,
      netRevenue: monthEndDetails.netRevenue,
      salary: monthEndDetails.salary,
      netRevenueAfterSalary: monthEndDetails.netRevenueAfterSalary,
      opex: monthEndDetails.opex,
      netRevenueAfterOPEX: monthEndDetails.netRevenueAfterOPEX,
      retentionPercent: monthEndDetails.retentionPercent,
      dmapayout: monthEndDetails.dmapayout,
      dsaId: user.companyId,
      connectorsCaseLessPayments: monthEndDetails.connectorsCaseLessPayments,
      connectorPayments: monthEndDetails.connectorPayments,
    };
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
      body: JSON.stringify(monthEndPayload),
    };
    setLoading(true);
    try {
      const response = await fetch(saveUrl, options);
      if (response.status === 401) {
        Cookie.remove("jwt_token");
        navigate("/login");
        return null;
      }
      if (response.ok) {
        await response.json();
        setAlert("Data saved successfully", "success");
        await fetchData();
      } else {
        const errorData = await response.json();
        setAlert(errorData.message || "Failed to save data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while saving data", "error");
    }
    setLoading(false);
    setOpenDialog(false);
  };

  const handleGetClick = () => {
    if (businessMonthID) {
      getMonthEndDetails();
    }
  };

  const tdsPercent = () => {
    if (!totalGrossPayout || !monthEndDetails?.tds) return 0;
    const tdsAmount = Math.round((Number(monthEndDetails.tds) / Number(totalGrossPayout)) * 100);
    return isNaN(tdsAmount) ? 0 : tdsAmount;
  };

  const calculateTotals = () => {
    const totalGross =
      monthEndDetails.grossPayoutOnLoan +
      monthEndDetails.grossPayoutOnInsurance +
      monthEndDetails.grossPayoutOnMutualFund;

    const totalDsa =
      monthEndDetails.dsaPayoutAmountOnLoan +
      monthEndDetails.dsaPayoutAmountOnMutualFund +
      monthEndDetails.dsaPayoutAmountOnInsurance;

    const profit = totalGross - totalDsa;

    setTotalGrossPayout(totalGross);
    setTotalDsaPayouts(totalDsa);
    setNetProfit(profit);
  };

  useEffect(() => {
    if (businessMonthID) {
      getMonthEndDetails();
    }
  }, []);

  useEffect(() => {
    calculateTotals();
  }, [monthEndDetails]);

  const handleConfirmSave = () => {
    saveMonthEndDetails();
  };

  // ─── retention % calculation ───────────────────────────────────────────────
  const retentionPercent =
    totalGrossPayout > 0
      ? ((monthEndDetails.netRevenueAfterSalary - monthEndDetails.opex) / totalGrossPayout) * 100
      : 0;

  // ─── P & L value ──────────────────────────────────────────────────────────
  const pandL = monthEndDetails.netRevenueAfterSalary - monthEndDetails.opex;

  return (
    <>
      {/* Loading dialog */}
      <Dialog open={loading} onClose={() => setLoading(false)}>
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="primary" />
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>

      {/* Snackbar */}
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>

      <TableContainer component={Paper} sx={monthEndStyles.tableContainer1}>
        {/* Date selector */}
        <Box sx={monthEndStyles.formContainer1}>
          <Box sx={{ display: "flex", flexDirection: "row", gap: "16px", flex: 1 }}>
            <Autocomplete
              options={monthIdData}
              getOptionLabel={(option) => option.date || ""}
              value={
                businessMonthID
                  ? monthIdData.find((item) => item.businessMonthID === businessMonthID)
                  : null
              }
              onChange={(event, newValue) => {
                setBusinessMonthID(newValue ? newValue.businessMonthID : "");
              }}
              PaperComponent={CustomPaper}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  {...params}
                  label="Date"
                  variant="outlined"
                  required
                  sx={{
                    height: 43,
                    width: "160px",
                    ...MInput.b,
                    "& .MuiInputBase-root": { height: "100%", minHeight: 43 },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                      "&.Mui-focused": { color: "red" },
                    },
                  }}
                />
              )}
            />
            <StyledButton onClick={handleGetClick}>Get</StyledButton>
          </Box>
        </Box>

        {/* Data Table */}
        <Table sx={monthEndStyles.table}>
          <TableBody>
            {/* ── Total Revenue ── */}
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>TOTAL REVENUE</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(totalGrossPayout)}
              </CustomTableCell>
            </TableRow>
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>ADDITIONAL PAYOUT</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails.additionalPayout)}
              </CustomTableCell>
            </TableRow>

            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>CONNECTOR CASE LESS PAYMENTS</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails.connectorsCaseLessPayments)}
              </CustomTableCell>
            </TableRow>
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>CONNECTOR PAYMENTS</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails.connectorPayments)}
              </CustomTableCell>
            </TableRow>

            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>RECOVERIES</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails.recoveries)}
              </CustomTableCell>
            </TableRow>

            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>GROSS PAYOUT + RECOVERIES</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails.grossPayoutPlusRecoveries)}
              </CustomTableCell>
            </TableRow>

            {/* ── TDS Amount ── */}
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>{tdsPercent()} % TDS AMOUNT</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails?.tds)}
              </CustomTableCell>
            </TableRow>

            {/* ── Net Revenue (After TDS) ── */}
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>NET REVENUE (AFTER TDS)</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails.netPayoutAfterTDS)}
              </CustomTableCell>
            </TableRow>

            {/* ── DSA Payouts ── */}
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>DSA PAYOUTS</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(totalDsaPayouts)}
              </CustomTableCell>
            </TableRow>

            {/* ── Net Revenue (After DSA) ── */}
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>NET REVENUE (AFTER DSA)</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails.netRevenue)}
              </CustomTableCell>
            </TableRow>

            {/* ── Salary ── */}
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>SALARY</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails.salary)}
              </CustomTableCell>
            </TableRow>

            {/* ── Net Revenue After Salary ── */}
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>NET REVENUE (AFTER SALARY)</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails.netRevenueAfterSalary)}
              </CustomTableCell>
            </TableRow>

            {/* ── Opex & Cost ── */}
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>OPEX & COST</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(monthEndDetails.opex)}
              </CustomTableCell>
            </TableRow>

            {/* ── P & L ── */}
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>P & L</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {fmtINR(pandL)}
              </CustomTableCell>
            </TableRow>

            {/* ── Retention % ── */}
            <TableRow sx={monthEndStyles.tableRow}>
              <CustomTableCell minWidth="100px" flexGrow={1}>
                <strong>RETENTION %</strong>
              </CustomTableCell>
              <CustomTableCell align="right" minWidth="100px" flexGrow={1}>
                {isNaN(retentionPercent)
                  ? "0.00%"
                  : `${retentionPercent.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}%`}
              </CustomTableCell>
            </TableRow>
          </TableBody>
        </Table>

        {/* Confirm Save Dialog */}
        <Dialog open={openDialog} onClose={handleCloseDailog}>
          <DialogContent sx={subDialogContentStyle}>
            <DialogContentText sx={dialogContentTextStyle}>
              This action will finalize all business transactions for the month. Are you sure you
              want to proceed?
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={monthEndStyles.dialogActions}>
            <StyledButton onClick={handleConfirmSave}>Yes</StyledButton>
            <StyledButton onClick={handleCloseDailog} variant="outlined">
              No
            </StyledButton>
          </DialogActions>
        </Dialog>

        <div style={monthEndStyles.buttonContainer}>
          <StyledButton onClick={() => setOpenDialog(true)}>Save</StyledButton>
        </div>
      </TableContainer>
    </>
  );
}

MonthlyOverView.propTypes = {
  url: PropTypes.string.isRequired,
  isItByDsa: PropTypes.bool.isRequired,
};
